import {ChangeEvent, useEffect, useRef, useState} from 'react'
import {useNavigate, useParams, useSearchParams} from 'react-router-dom'
import {
  Breadcrumb,
  Button,
  ButtonGroup,
  Col,
  Dropdown,
  Form,
  Row,
  Spinner,
  Card,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap'
import {useDisclourse} from '../../hooks/useDisclourse'
//import {AsideMenucommissionReports} from './components/AsideMenucommissionReports'
import {useLazyQuery, useQuery, useMutation} from '@apollo/client'
import {GET_ALL_COMMISSION_REPORTS_DETAILS_API} from '../../gql/queries/commissionReportsDetailsApiQueries'
import {GET_COMMISSION_REPORT_BY_ID_API} from '../../gql/queries/commissionReportsApiQueries'
import {UPDATE_COMMISSION_REPORT_DETAIL} from '../../gql/mutations/commissionReportDetailMutations'
import {IResAllListUsers} from '../../types/users'
import {GET_ALL_USERS_LIST} from '../../gql/queries/usersQuery'
import {toast} from 'react-toastify'
import {
  IResCommissionReportsDetailsAPI,
  NodeCommissionReportDetail,
  IResCreateCommissionReportDetail,
} from '../../types/commissionReportDetailApi'
import {hasPermission, parseId, parsePrice} from '../../helpers'
import moment from 'moment'
import {BadgeStatus} from './components/BadgeStatus'
import {ALL_PERMISSIONS, SIZE_PAGE_DEFAULT} from '../../helpers/consts'
import {PaginationUtils} from '../shared/PaginationUtils'
import {PaginationSection} from '../shared/PaginationSection'
import {ModalEditCommissionReport} from '../commissionReports/components/ModalEditCommissionReport'
import {NodeCommissionReport} from '../../types/commissionReportApi'
import {useUploadFile} from '../../hooks/useUploadFile'
import {UPLOAD_PAYMENT_COMMISSION_REPORT} from '../../gql/mutations/commissionReportMutations'
import {IResUploadPaymentCommissionReport} from '../../types/commissionReportApi'
import {ModalEditCommissionReportDetail} from './components/ModalEditCommissionReportDetail'
import {ModalAssignAgent} from './components/ModalAssignAgent'
import {ModalDeleteCommissionReportDetail} from './components/ModalDeleteCommissionReportDetail'
import {ModalAddCommissionReportDetail} from './components/ModaAddCommissionReportDetail'
import {
  TOGGLE_STATUS_COMMISSION_REPORT,
  CALCULATE_DEDUCTIONS_COMMISSION_REPORT,
} from '../../gql/mutations/commissionReportMutations'
import {ModalConfirmation} from '../commissionReports/components/ModalConfirmation'
import {ModalNotesClaims} from './components/ModalNotesClaims'
import {useGetUser} from '../../store/userStore'
import {OffcanvasSearchCommissionDetails} from './components/OffcanvasSearchCommissionDetails'
import {GET_ALL_USERS_FILTER} from '../../gql/queries/usersQuery'
import {IResAllUsers} from '../oneUser/oneUserTypes'
import {URL} from '../../gql/client'
import {MultiSelectWithActions} from '../../components/MultiSelectWithActions'

export const CommissionReportsDetailsPage = () => {
  const permissions = useGetUser((s) => s.user?.permissions)
  const user = useGetUser((s) => s.user)
  const canEditCommission =
    permissions && hasPermission(permissions, ALL_PERMISSIONS.EDIT_COMMISSION)
  const canUseCommissionsFinder =
    permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_COMMISSION_FINDER)
  const userGroups = useGetUser((s) => s.user?.groups) || []
  const currentUserId = useGetUser((s) => s.user?.user?.id)
  const isAgente = userGroups.includes('Agente')
  // --- React Router
  const {id, client} = useParams<{id: string; client?: string}>()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  // --- Estado para el ID y nombre del reporte
  const [reportId, setReportId] = useState<string | null>(null)
  const [formName, setFormName] = useState<string | null>(null)

  // --- GraphQL Hooks
  const [getOneCommissionReport, {data: commissionReportById}] = useLazyQuery(
    GET_COMMISSION_REPORT_BY_ID_API,
    {
      fetchPolicy: 'no-cache',
    }
  )

  const [
    gqlGetCommissionReportsDetails,
    {data: dataAllCommissionReportsDetails, loading, error, refetch: refetchEntries},
  ] = useLazyQuery<IResCommissionReportsDetailsAPI>(GET_ALL_COMMISSION_REPORTS_DETAILS_API, {
    fetchPolicy: 'no-cache',
  })

  const [gqlUpdate, {data: dataUpdate, loading: loadingUpdate, error: errorUpdate}] =
    useMutation<IResCreateCommissionReportDetail>(UPDATE_COMMISSION_REPORT_DETAIL)

  const {data: dataMembers, error: errorMembers} = useQuery<IResAllUsers>(GET_ALL_USERS_FILTER, {
    fetchPolicy: 'no-cache',
    variables: {requireNpn: true},
  })

  // --- Modales y UI
  const {isOpen, onClose, onOpen} = useDisclourse()
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const [infoEdit, setInfoEdit] = useState<NodeCommissionReport | null>(null)
  const [isOpenEditDetail, setIsOpenEditDetail] = useState(false)
  const [infoEditDetail, setInfoEditDetail] = useState<NodeCommissionReportDetail | null>(null)
  const [isOpenAssignAgent, setIsOpenAssignAgent] = useState(false)
  const [isOpenNotesClaims, setIsOpenNotesClaims] = useState(false)

  // -- Reopen and close commission report for toggling status
  const [gqlToggleStatusCommissionReport] = useMutation(TOGGLE_STATUS_COMMISSION_REPORT)
  const [isOpenToggleModal, setIsOpenToggleModal] = useState(false)
  const [toggleAction, setToggleAction] = useState<'close' | 'reopen'>('close')

  const handleToggleStatus = async () => {
    if (!report?.id) return

    try {
      await gqlToggleStatusCommissionReport({
        variables: {
          id: parseId(report.id),
          newStatus: report.status === 'DRAFT' ? 'COMPLETED' : 'DRAFT',
        },
      })
      toast.success(
        report.status === 'DRAFT'
          ? 'Commission Report closed successfully'
          : 'Commission Report reopened successfully'
      )
      await refetchReport()
      await refetchEntries()
    } catch (error: any) {
      toast.error(`Error: ${error.message}`)
    } finally {
      setIsOpenToggleModal(false)
    }
  }

  const {
    isOpen: isOpenDeleteCommissionReportDetail,
    onClose: onCloseDeleteCommissionReportDetail,
    onOpen: onOpenDeleteCommissionReportDetail,
  } = useDisclourse()

  const [isOpenDeductionsModal, setIsOpenDeductionsModal] = useState(false)
  const [calculateDeductions, {loading: loadingDeductions}] = useMutation(
    CALCULATE_DEDUCTIONS_COMMISSION_REPORT
  )
  const [loadingExport, setLoadingExport] = useState(false)

  const handleConfirmCalculateDeductions = async () => {
    try {
      const {data} = await calculateDeductions({variables: {id: parseId(report.id)}})
      if (data?.commissionReportCalculateDeductionsMutation?.success) {
        toast.success('✅ Deductions calculated successfully')
      } else {
        toast.error('❌ Failed to calculate deductions')
      }
    } catch (error) {
      console.error(error)
      toast.error('⚠️ Unexpected error calculating deductions')
    } finally {
      setIsOpenDeductionsModal(false)
    }
  }

  // --- Filtros y paginación
  const [tabFilters, setTabFilters] = useState('CommissionReportsDetails')
  const [valueUser, setValueUser] = useState<string[]>(
    isAgente && currentUserId ? [currentUserId] : []
  )
  // Antes del useState
  type IFilterStatus = 'all' | 'PENDING' | 'APPROVED' | 'NOT_ASSIGNED' | 'CANCELED'
  type IFilterType = 'all' | 'COMMISSION' | 'DEDUCTION' | 'CHARGEBACK' | 'BONUS'

  const [filterStatus, setFilterStatus] = useState<IFilterStatus>('all')
  const [filterType, setFilterType] = useState<IFilterType>('all')
  const [filterHasActiveClaims, setFilterHasActiveClaims] = useState<boolean | null>(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [offset, setOffset] = useState(0)
  const [first, setFirst] = useState(50) // Por defecto 50 elementos
  const [isPag, setIsPag] = useState(false)
  const [page, setPage] = useState(1)

  // --- Datos del detalle
  const [dataArr, setDataArr] = useState<
    IResCommissionReportsDetailsAPI['allCommissionReportsDetails']['edges']
  >([])
  const [commissionReportsDetailsSelected, setCommissionReportsDetailsSelected] = useState<
    {id: string; client: string; status: string; user: string}[] | undefined
  >([])

  const initialDetailData = {client: '', memberId: '', status: '', user: ''}
  const [detailData, setDetailData] = useState(initialDetailData)

  // --- Efecto para cargar reporte al inicio
  useEffect(() => {
    const decodedId = id ? String(parseId(id)) : null
    if (decodedId) {
      setReportId(decodedId)
      getOneCommissionReport({variables: {id: decodedId}})
    }
  }, [id, getOneCommissionReport])

  // --- Efecto para guardar nombre del reporte
  useEffect(() => {
    if (commissionReportById?.commissionReportById?.name) {
      setFormName(commissionReportById.commissionReportById.name)
    }
  }, [commissionReportById])

  useEffect(() => {
    const memberId = searchParams.get('memberId') || ''

    if (client) {
      const decodedClient = decodeURIComponent(client)
      setDetailData((prev) => ({
        ...prev,
        client: decodedClient,
        memberId,
      }))
      return
    }

    if (memberId) {
      setDetailData((prev) => ({
        ...prev,
        memberId,
      }))
    }
  }, [client, searchParams])

  // --- Función para recargar reporte individual
  const refetchReport = async () => {
    if (reportId) {
      const {data} = await getOneCommissionReport({
        variables: {id: reportId},
        fetchPolicy: 'no-cache',
      })
      if (data?.commissionReportById) {
        setFormName(data.commissionReportById.name)
      }
    }
  }

  // --- Obtener detalles del reporte con filtros
  const handleFilters = () => {
    const commissionReportId = id ? parseId(id) : null
    const userIds =
      valueUser && valueUser.length > 0 ? valueUser.map((userId) => parseId(userId)) : null

    gqlGetCommissionReportsDetails({
      variables: {
        first,
        offset: (currentPage - 1) * first,
        client: detailData.client || null,
        memberId: detailData.memberId || null,
        status: filterStatus === 'all' ? null : filterStatus,
        commissionType: filterType === 'all' ? null : filterType,
        user: userIds,
        commissionReport: commissionReportId,
        activeClaim: filterHasActiveClaims,
      },
    })
  }

  useEffect(() => {
    const shouldRun = reportId && (client ? detailData.client : true)
    if (shouldRun) {
      handleFilters()
      setCommissionReportsDetailsSelected([])
    }
  }, [
    reportId,
    first,
    currentPage,
    tabFilters,
    detailData.client, // importante que esto esté
    detailData.memberId,
  ])

  // --- Cargar datos de detalles y Validacion de totales
  const [totals, setTotals] = useState({
    pending: 0,
    approved: 0,
    notAssigned: 0,
    grand: 0,
    approvedWithPolicy: 0,
    approvedWithoutPolicy: 0,
  })

  useEffect(() => {
    if (!dataAllCommissionReportsDetails) return

    const details = dataAllCommissionReportsDetails.allCommissionReportsDetails

    // Actualizar la tabla de datos
    setDataArr(isPag ? (prev) => [...prev, ...details.edges] : details.edges)

    // Actualizar los totales
    setTotals({
      pending: details.totalPending || 0,
      approved: details.totalApproved || 0,
      notAssigned: details.totalNotAssigned || 0,
      grand: details.grandTotal || 0,
      approvedWithPolicy: details.totalApprovedWithPolicy || 0,
      approvedWithoutPolicy: details.totalApprovedWithoutPolicy || 0,
    })
  }, [dataAllCommissionReportsDetails])

  // --- Manejo de errores
  useEffect(() => {
    if (error) toast.error(`Error: ${error.message}`)
  }, [error])

  // --- Helpers UI
  const isAllSelected =
    commissionReportsDetailsSelected?.length ===
    dataAllCommissionReportsDetails?.allCommissionReportsDetails?.edges?.length

  const toggleAll = () => {
    if (isAllSelected) {
      setCommissionReportsDetailsSelected([])
    } else if (dataAllCommissionReportsDetails?.allCommissionReportsDetails?.edges?.length) {
      const allIds = dataAllCommissionReportsDetails.allCommissionReportsDetails.edges.map(
        (edge) => ({
          id: edge.node.id,
          client: edge.node.client ?? '',
          status: edge.node.status,
          user: edge.node.user
            ? `${edge.node.user?.firstName ?? ''} ${edge.node.user?.lastName ?? ''}`
            : '',
        })
      )
      setCommissionReportsDetailsSelected(allIds)
    }
  }

  const toggleOne = (id: string) => {
    if (!id || !commissionReportsDetailsSelected) return

    const exists = commissionReportsDetailsSelected.find((x) => x.id === id)
    if (exists) {
      setCommissionReportsDetailsSelected(
        commissionReportsDetailsSelected.filter((x) => x.id !== id)
      )
    } else {
      const found = dataAllCommissionReportsDetails?.allCommissionReportsDetails?.edges.find(
        (e) => e.node?.id === id
      )
      if (found?.node) {
        setCommissionReportsDetailsSelected([
          ...commissionReportsDetailsSelected,
          {
            id: found.node.id,
            client: found.node.client ?? '',
            status: found.node.status ?? '',
            user: found.node.user
              ? `${found.node.user?.firstName ?? ''} ${found.node.user?.lastName ?? ''}`
              : '',
          },
        ])
      }
    }
  }

  const handleClientName = () => {
    handleFilters()
  }

  const updatePage = (n: number) => setCurrentPage(n)

  const handleUpdateCommissionReportDetail = async (id: string, data: any) => {
    return await gqlUpdate({
      variables: {
        id: parseId(id),
        input: data,
      },
    })
  }

  const handleStatusChange = async (node, newStatus) => {
    const cleanData = removeKeysDeep(node, [
      'id',
      '__typename',
      'user',
      'policy',
      'commissionReport',
    ])
    cleanData.status = newStatus

    // Convertir stateEU de objeto a ID si existe
    if (cleanData.stateEU && typeof cleanData.stateEU === 'object') {
      cleanData.stateEU = parseId(cleanData.stateEU.id) || null
    }

    try {
      await handleUpdateCommissionReportDetail(node.id, cleanData)
      await refetchEntries()
    } catch (err) {
      toast.error('Error updating status')
    }
  }

  const removeKeysDeep = (obj: any, keysToRemove: string[] = ['__typename']): any => {
    if (Array.isArray(obj)) return obj.map((item) => removeKeysDeep(item, keysToRemove))
    if (obj && typeof obj === 'object') {
      const newObj: Record<string, any> = {}
      for (const key in obj) {
        if (!keysToRemove.includes(key)) {
          newObj[key] = removeKeysDeep(obj[key], keysToRemove)
        }
      }
      return newObj
    }
    return obj
  }

  const safeParseId = (value: any): string | null => {
    if (value === null || value === undefined || value === '') return null
    const parsed = parseId(value)
    if (!parsed || parsed === 0 || parsed === '0') return null
    return String(parsed)
  }

  const formatEffectivePeriod = (
    effectiveMonth?: number | null,
    effectiveYear?: number | null,
    monthFormat: 'MMM' | 'MMMM' = 'MMM'
  ): string | null => {
    const month = Number(effectiveMonth)
    const year = Number(effectiveYear)
    const hasMonth = Number.isFinite(month) && month > 0
    const hasYear = Number.isFinite(year) && year > 0

    if (hasMonth && hasYear) {
      return moment(`${year}-${month}-01`, 'YYYY-M-DD').format(`${monthFormat} YYYY`)
    }

    if (hasMonth) {
      return moment().month(month - 1).format(monthFormat)
    }

    if (hasYear) {
      return String(year)
    }

    return null
  }

  const handleDownloadDetails = async () => {
    if (!user?.token) return

    const currentReport = commissionReportById?.commissionReportById
    const commissionReportId = safeParseId(currentReport?.id)
    if (!currentReport || !commissionReportId) return

    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${user.token}`)

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
    }

    const rawParams: Record<string, string | null> = {
      id: commissionReportId,
      client: detailData.client || null,
      memberId: detailData.memberId || null,
      status: filterStatus === 'all' ? null : filterStatus,
      commissionType: filterType === 'all' ? null : filterType,
      user:
        valueUser && valueUser.length > 0
          ? valueUser.map((userId) => safeParseId(userId)).filter(Boolean).join(',')
          : null,
    }

    if (filterHasActiveClaims !== null) {
      rawParams.activeClaim = String(filterHasActiveClaims)
    }

    const params = new URLSearchParams()

    Object.entries(rawParams).forEach(([key, value]) => {
      if (value != null && value !== '') {
        params.append(key, value)
      }
    })

    setLoadingExport(true)
    try {
      const url = `${URL}/export-commission-details-excel?${params.toString()}`
      const response = await fetch(url, requestOptions)
      if (!response.ok) throw new Error('Error al exportar')
      const blob = await response.blob()
      const downloadUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = downloadUrl
      link.download = `${currentReport.name} - details - ${moment().format('YY-MM-DD')}.xlsx`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(downloadUrl)
    } catch (err) {
      toast.error(`ERROR: ${(err as {message: string}).message}`)
    } finally {
      setLoadingExport(false)
    }
  }

  // --- Paginación
  const totalCommissionReportsDetails =
    dataAllCommissionReportsDetails?.allCommissionReportsDetails?.totalCount ?? 0

  const totalPages = Math.ceil(totalCommissionReportsDetails / first)

  const {start, end} = PaginationUtils.getPaginationRange(
    currentPage,
    first,
    totalCommissionReportsDetails
  )

  const {
    isOpen: isOpenSearchDetails,
    onOpen: onOpenSearchDetails,
    onClose: onCloseSearchDetails,
  } = useDisclourse()

  const floatingTabStyle: React.CSSProperties = {
    position: 'fixed',
    top: '50%',
    right: 0,
    transform: 'translateY(-50%)',
    zIndex: 1051, // por encima del contenido
    borderRadius: '10px 0 0 10px',
    padding: '8px 12px',
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
  }

  const filtersGridStyle: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: isAgente
      ? 'minmax(0, 2.2fr) minmax(0, 2.2fr) minmax(0, 2.2fr) minmax(120px, 0.8fr)'
      : 'minmax(0, 2.2fr) minmax(0, 2.2fr) minmax(0, 2.2fr) minmax(0, 2.2fr) minmax(120px, 0.8fr)',
    gap: '0.45rem',
    width: '100%',
    alignItems: 'stretch',
  }

  const compactFilterControlStyle: React.CSSProperties = {
    width: '100%',
    height: '38px',
    minWidth: 0,
    borderRadius: '0.475rem',
    borderColor: '#dbdfe9',
    color: '#3f4254',
    fontSize: '0.95rem',
    fontWeight: 500,
    backgroundColor: '#fff',
  }

  const compactSearchButtonStyle: React.CSSProperties = {
    width: '100%',
    height: '38px',
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
  }

  const agentMenuPortalTarget = typeof document !== 'undefined' ? document.body : undefined

  const agentSelectStyles = {
    control: (base: any) => ({
      ...base,
      minHeight: '38px',
      height: '38px',
      borderRadius: '0.475rem',
      borderColor: '#dbdfe9',
      boxShadow: 'none',
      backgroundColor: '#fff',
    }),
    valueContainer: (base: any) => ({
      ...base,
      minHeight: '38px',
      padding: '0 12px',
    }),
    input: (base: any) => ({
      ...base,
      margin: 0,
      padding: 0,
      color: '#3f4254',
      fontSize: '0.95rem',
      fontWeight: 500,
    }),
    placeholder: (base: any) => ({
      ...base,
      color: '#3f4254',
      margin: 0,
      fontSize: '0.95rem',
      fontWeight: 500,
    }),
    singleValue: (base: any) => ({
      ...base,
      color: '#3f4254',
      fontSize: '0.95rem',
      fontWeight: 500,
    }),
    multiValueLabel: (base: any) => ({
      ...base,
      fontSize: '0.9rem',
      fontWeight: 500,
    }),
    indicatorsContainer: (base: any) => ({
      ...base,
      height: '38px',
    }),
    dropdownIndicator: (base: any) => ({
      ...base,
      padding: '0 8px',
    }),
    clearIndicator: (base: any) => ({
      ...base,
      padding: '0 8px',
    }),
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 2000,
    }),
    menu: (base: any) => ({
      ...base,
      zIndex: 2000,
    }),
  }

  // --- Gestion de upload de excel

  const [uploadFile, {data: dataFile, error: errorFile, loading: loadingFile}] =
    useUploadFile<IResUploadPaymentCommissionReport>()

  const fileInputRef = useRef<HTMLInputElement>(null)
  const uploadFileNameRef = useRef<string>('')
  const pendingFileRef = useRef<File | null>(null)
  const [isOpenUploadTypeModal, setIsOpenUploadTypeModal] = useState(false)
  const [uploadType, setUploadType] = useState<'commission' | 'bonus'>('commission')

  useEffect(() => {
    if (errorFile) toast.error(`Error: ${errorFile}`)
  }, [errorFile])

  useEffect(() => {
    const result = dataFile?.commissionReportUploadPaymentMutation
    if (!result) return

    const {success, message, errors} = result

    if (success) {
      toast.success(
        `Payment file "${uploadFileNameRef.current || 'commission-report-payment.xlsx'}" uploaded successfully`
      )
      uploadFileNameRef.current = ''
      refetchEntries()
    } else {
      const errorMessage =
        errors
          ?.map((err) => err?.message)
          .filter(Boolean)
          .join(', ') ||
        message ||
        'Something went wrong during upload.'
      toast.error(`Error: ${errorMessage}`)
    }
  }, [dataFile, refetchEntries])

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event?.target?.files?.[0]
    if (!file) return

    // Guardar el archivo y abrir modal de confirmación
    pendingFileRef.current = file
    setUploadType('commission') // Reset to default
    setIsOpenUploadTypeModal(true)

    event.target.value = ''
  }

  const handleConfirmUpload = () => {
    const file = pendingFileRef.current
    if (!file) return

    uploadFileNameRef.current = file.name

    const formdata = new FormData()
    formdata.append('0', file, file.name)
    formdata.append('map', '{"0": ["variables.excelFile"]}')
    toast.info(`Starting upload: ${file.name}${uploadType === 'bonus' ? ' (as BONUS)' : ''}`)
    if (!id) {
      toast.error('Missing report ID')
      return
    }

    const commissionReportId = parseId(id)

    const obj = {
      query: UPLOAD_PAYMENT_COMMISSION_REPORT,
      variables: {
        id: commissionReportId,
        excelFile: null,
        uploadType: uploadType,
      },
    }
    formdata.append('operations', JSON.stringify(obj))
    uploadFile(formdata)

    pendingFileRef.current = null
    setIsOpenUploadTypeModal(false)
  }

  const handleButtonClick = () => {
    fileInputRef?.current?.click()
  }

  // --- Validación de carga
  if (!commissionReportById || !commissionReportById.commissionReportById) {
    return (
      <div className='d-flex flex-center' style={{height: '30vh'}}>
        <Spinner animation='border' />
      </div>
    )
  }

  // --- Report listo
  const report = commissionReportById.commissionReportById

  // --- Render principal (return) se mantiene igual ---
  return (
    <div className='policies-page'>
      <header className='header'>
        <Breadcrumb>
          <Breadcrumb.Item className='fs-3' onClick={(e) => navigate('/commissions')}>
            Reports List
          </Breadcrumb.Item>
          <Breadcrumb.Item className='fs-3'>Detailed</Breadcrumb.Item>
        </Breadcrumb>
        <div className='policies-summary summary-cards mb-3'>
          <Card className='card-summary green flex-fill mx-2 text-center'>
            <Card.Title>Approved Total Amount</Card.Title>
            <Card.Body>
              {loading && <Spinner animation='border' />}
              {parsePrice(totals.approved ?? 0)}
            </Card.Body>
          </Card>
          <Card className='card-summary warning flex-fill mx-2 text-center'>
            <Card.Title>Pending Total Amount</Card.Title>
            <Card.Body>
              {loading && <Spinner animation='border' />}
              {parsePrice(totals.pending ?? 0)}
            </Card.Body>
          </Card>
          <Card className='card-summary canceled flex-fill mx-2 text-center'>
            <Card.Title>Not Assigned Total Amount</Card.Title>
            <Card.Body>
              {loading && <Spinner animation='border' />}
              {parsePrice(totals.notAssigned ?? 0)}
            </Card.Body>
          </Card>
        </div>
      </header>

      <Row className='commissionReports'>
        <Col className='container'>
          <div className='policies-container'>
            <div className='title-header'>
              <h3>
                Report: {report.name}{' '}
                {canEditCommission && !isAgente && (
                  <span
                    style={{cursor: 'pointer'}}
                    className='text-primary ms-2'
                    onClick={() => {
                      setInfoEdit(report)
                      setIsOpenEdit(true)
                    }}
                  >
                    <i className='bi bi-pencil-square' /> Edit
                  </span>
                )}
                <br />
                <small>
                  Date: {formatEffectivePeriod(report.effectiveMonth, report.effectiveYear, 'MMMM') || ''}
                </small>
              </h3>

              <div className='d-flex gap-2 align-items-center'>
                {canEditCommission && (
                  <>
                    {report.status === 'DRAFT' && (
                      <Button
                        size='sm'
                        onClick={handleButtonClick}
                        disabled={loadingFile}
                      >
                        {loadingFile ? (
                          <>
                            <Spinner animation='border' size='sm' className='me-2' />
                            Uploading...
                          </>
                        ) : (
                          <>
                            <i className='bi bi-upload fs-6' /> Upload File
                          </>
                        )}
                      </Button>
                    )}
                    <input
                      type='file'
                      ref={fileInputRef}
                      style={{display: 'none'}}
                      accept='.xlsx,.xls'
                      onChange={handleFileChange}
                    />

                    {!isAgente && (
                      <Button
                        size='sm'
                        onClick={() => navigate(`/commissions/${report.id}/conciliation`)}
                      >
                        {report.status === 'DRAFT' ? (
                          <>
                            <i className='bi bi-list-check' /> Conciliation
                          </>
                        ) : (
                          <>
                            <i className='bi bi-list-check' /> Logs conciliated
                          </>
                        )}
                      </Button>
                    )}

                    {report.status === 'DRAFT' && (
                      <Button
                        size='sm'
                        onClick={() => {
                          onOpen()
                        }}
                      >
                        <i className='bi bi-plus fs-3' /> Add record
                      </Button>
                    )}

                    {report.status === 'DRAFT' && (
                      <Button
                        size='sm'
                        disabled={loadingDeductions}
                        onClick={() => setIsOpenDeductionsModal(true)}
                      >
                        {loadingDeductions ? (
                          <Spinner animation='border' size='sm' />
                        ) : (
                          <>
                            <i className='bi bi-calculator' /> Calculate Deductions
                          </>
                        )}
                      </Button>
                    )}
                  </>
                )}
                <Button size='sm' disabled={loadingExport} onClick={handleDownloadDetails}>
                  {loadingExport ? (
                    <>
                      <Spinner animation='border' size='sm' />{' '}
                    </>
                  ) : (
                    <i className='bi bi-download'></i>
                  )}
                  Export
                </Button>
                <Button size='sm' onClick={() => navigate(`/commissions/${report.id}/payroll`)}>
                  <>
                    <i className='bi bi-cash-coin me-1' /> Payroll
                  </>
                </Button>
                {canEditCommission && !isAgente && (
                  <>
                    <Button
                      size='sm'
                      variant={report.status === 'DRAFT' ? 'danger' : 'success'}
                      className='ms-2'
                      onClick={() => {
                        setToggleAction(report.status === 'DRAFT' ? 'close' : 'reopen')
                        setIsOpenToggleModal(true)
                      }}
                    >
                      {report.status === 'DRAFT' ? (
                        <>
                          <i className='bi bi-lock-fill' /> Finish and Close Report
                        </>
                      ) : (
                        <>
                          <i className='bi bi-unlock-fill' /> Reopen Report
                        </>
                      )}
                    </Button>
                  </>
                )}
              </div>
            </div>

            <div className='filters-header'>
              <div className='d-flex flex-column gap-3'>
                <div style={filtersGridStyle}>
                  <div style={{minWidth: 0}}>
                    <Form.Control
                      placeholder='Filter by client name or member ID'
                      aria-label="Client's name or member ID with two button addons"
                      onChange={(e) =>
                        setDetailData((prev) => ({
                          ...prev,
                          client: e.target.value,
                        }))
                      }
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault()
                          handleClientName()
                        }
                      }}
                      value={detailData.client}
                      disabled={false}
                      style={compactFilterControlStyle}
                    />
                  </div>
                  <div style={{minWidth: 0}}>
                    <Form.Select
                      value={filterStatus}
                      aria-label='Filter by status'
                      onChange={(e) => setFilterStatus(e.target.value as IFilterStatus)}
                      style={compactFilterControlStyle}
                    >
                      <option value='all'>Filter by Status</option>
                      <option value='PENDING'>Pending</option>
                      <option value='APPROVED'>Approved</option>
                      <option value='NOT_ASSIGNED'>Not Assigned</option>
                      <option value='CANCELED'>Canceled</option>
                    </Form.Select>
                  </div>
                  <div style={{minWidth: 0}}>
                    <Form.Select
                      value={filterType}
                      aria-label='Filter by Type'
                      onChange={(e) => setFilterType(e.target.value as IFilterType)}
                      style={compactFilterControlStyle}
                    >
                      <option value='all'>Filter by Type</option>
                      <option value='COMMISSION'>Commission</option>
                      <option value='DEDUCTION'>Deduction</option>
                      <option value='CHARGEBACK'>Chargeback</option>
                      <option value='BONUS'>Bonus</option>
                    </Form.Select>
                  </div>
                  {!isAgente && (
                    <div style={{minWidth: 0}}>
                      <MultiSelectWithActions
                        value={
                          valueUser && valueUser.length > 0
                            ? dataMembers?.allUsers.edges
                                .filter(({node}) => valueUser.includes(node.id))
                                .map(({node}) => ({
                                  value: node.id,
                                  label: `${node.firstName} ${node.lastName} - ${node.email}${
                                    node.npn ? ` (${node.npn})` : ''
                                  }`,
                                }))
                            : []
                        }
                        options={
                          dataMembers?.allUsers.edges.map(({node}) => ({
                            value: node.id,
                            label: `${node.firstName} ${node.lastName} - ${node.email}${
                              node.npn ? ` (${node.npn})` : ''
                            }`,
                          })) || []
                        }
                        onChange={(selected: any) => {
                          const selectedValues = Array.isArray(selected)
                            ? selected.map((opt: any) => opt.value)
                            : []
                          setValueUser(selectedValues)
                        }}
                        placeholder='Filter by Agent'
                        menuPortalTarget={agentMenuPortalTarget}
                        menuPosition='fixed'
                        styles={agentSelectStyles}
                      />
                    </div>
                  )}
                  <div style={{minWidth: 0}}>
                    <Button
                      className='w-100'
                      disabled={false}
                      onClick={() => handleFilters()}
                      variant='outline-success'
                      style={{...compactSearchButtonStyle, border: '1px solid #dbdfe9'}}
                    >
                      Search
                    </Button>
                  </div>
                </div>

              </div>
            </div>
            <div className='results-header'>
              <PaginationSection
                first={first}
                setFirst={(n) => {
                  setFirst(n)
                  setPage(1)
                  setOffset(0)
                }}
                currentPage={currentPage}
                totalPages={totalPages}
                start={start}
                end={end}
                totalPolicies={totalCommissionReportsDetails}
                updatePage={updatePage}
                PaginationUtils={PaginationUtils}
                pageSizeOptions={[50, 100, 500]}
              />
              <div className='col-md-3'>
                <div className='results-filter'>
                  <Col lg={12} md={12} sm={12} xs={12}></Col>
                </div>
              </div>
            </div>

            <div className='table-responsive table table-striped table-hover '>
              <table
                className='table-scrollable table-scroll  table table-striped table-hover '
                style={{whiteSpace: 'nowrap'}}
              >
                <thead>
                  <tr role='row'>
                    <th className='fw-bold'>Client</th>
                    <th className='fw-bold'>Agent</th>
                    <th className='fw-bold'>Type</th>
                    <th className='fw-bold'>Status</th>

                    <th className='fw-bold'>Rate</th>
                    <th className='fw-bold'>Members</th>
                    <th className='fw-bold'>Subtotal</th>
                    <th className='fw-bold'>Actions</th>
                  </tr>
                </thead>
                {(loading || !dataAllCommissionReportsDetails) && !isPag ? (
                  <tbody>
                    <tr>
                      <td colSpan={8}>
                        <div className='d-flex flex-center' style={{height: '30vh'}}>
                          <Spinner animation='border' />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    {(loading || dataArr.length === 0) && (
                      <tr>
                        <td colSpan={8}>
                          <div className='d-flex flex-center' style={{height: '30vh'}}>
                            {loading ? (
                              <Spinner animation='border' />
                            ) : (
                              'There are no commission report details currently added'
                            )}
                          </div>
                        </td>
                      </tr>
                    )}

                    {!loading &&
                      (() => {
                        const startIndex = first * page - first
                        const endIndex = first * page
                        const currentPageItems = dataArr.slice(startIndex, endIndex)

                        const withPolicy = currentPageItems.filter(({node}) => node.policy)
                        const withoutPolicy = currentPageItems.filter(({node}) => !node.policy)

                        // Si el reporte está COMPLETED, no separar por secciones
                        const isDraft = report.status === 'DRAFT'

                        return (
                          <>
                            {isDraft && withoutPolicy.length > 0 && (
                              <>
                                <tr>
                                  <td
                                    colSpan={8}
                                    style={{
                                      backgroundColor: '#337ab7',
                                      color: 'black',
                                      textAlign: 'left',
                                      padding: '8px',
                                    }}
                                  >
                                    <strong>Rows added manually</strong>
                                  </td>
                                </tr>
                                {withoutPolicy.map(({node}) => (
                                  <tr key={node.id}>
                                    {/* Repite aquí el mismo contenido que arriba */}
                                    <td>
                                      <div>
                                        <span
                                          className='text-primary'
                                          style={{cursor: 'pointer'}}
                                          data-tooltip-id={`myt2${parseId(node.id)}`}
                                        >
                                          {node.client}
                                          {node.activeClaim && (
                                            <i
                                              className='bi bi-exclamation-circle-fill text-danger'
                                              title='This client has an active claim'
                                            />
                                          )}
                                        </span>
                                        {(node.memberId || node.stateEU?.code) && (
                                          <>
                                            {node.memberId && <p className='m-0'>Member ID: {node.memberId}</p>}
                                            {node.stateEU?.code && <p className='m-0'>State: {node.stateEU?.code}</p>}
                                          </>
                                        )}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <span className='text-primary'>
                                          {node.user.firstName} {node.user.lastName}
                                        </span>
                                        <p style={{maxWidth: '140px', wordBreak: 'break-all'}}>
                                          NPN: {node.user.npn}
                                        </p>
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <span
                                          className={`commission-type ${node.commissionType.toLowerCase()}`}
                                          style={{maxWidth: '140px', wordBreak: 'break-all'}}
                                        >
                                          {node.commissionType}
                                        </span>
                                        {formatEffectivePeriod(node.effectiveMonth, node.effectiveYear) && (
                                          <p className='m-0'>
                                            Month:{' '}
                                            {formatEffectivePeriod(node.effectiveMonth, node.effectiveYear)}
                                          </p>
                                        )}
                                      </div>
                                    </td>
                                    <td>
                                      <BadgeStatus state={node.status} />
                                    </td>
                                    <td>{parsePrice(node.rate)}</td>
                                    <td>{node.members}</td>
                                    <td>{parsePrice(node.subtotal)}</td>
                                    <td
                                      className='d-flex gap-2 align-items-center'
                                      style={{minWidth: '120px'}}
                                    >
                                      {canEditCommission && report.status === 'DRAFT' && (
                                        <>
                                          {/* Icono de check (verde) */}
                                          {(node.status === 'PENDING' ||
                                            node.status === 'NOT_ASSIGNED') && (
                                              <OverlayTrigger
                                                placement='top'
                                                overlay={
                                                  <Tooltip id={`tooltip-approve-${node.id}`}>
                                                    Mark as Approved
                                                  </Tooltip>
                                                }
                                              >
                                                <i
                                                  className='bi bi-check-square-fill text-success'
                                                  style={{cursor: 'pointer', fontSize: '1.2rem'}}
                                                  onClick={() =>
                                                    handleStatusChange(node, 'APPROVED')
                                                  }
                                                />
                                              </OverlayTrigger>
                                            )}

                                          {/* Icono de X (rojo) */}
                                          {(node.status === 'PENDING' ||
                                            node.status === 'APPROVED') && (
                                              <OverlayTrigger
                                                placement='top'
                                                overlay={
                                                  <Tooltip id={`tooltip-notassigned-${node.id}`}>
                                                    Mark as Not Assigned
                                                  </Tooltip>
                                                }
                                              >
                                                <i
                                                  className='bi bi-x-square-fill text-danger'
                                                  style={{cursor: 'pointer', fontSize: '1.2rem'}}
                                                  onClick={() =>
                                                    handleStatusChange(node, 'NOT_ASSIGNED')
                                                  }
                                                />
                                              </OverlayTrigger>
                                            )}
                                          <Dropdown as={ButtonGroup}>
                                            <Button
                                              variant='outline-primary'
                                              size='sm'
                                              style={{border: '1px solid #3e97ff'}}
                                            >
                                              Actions
                                            </Button>
                                            <Dropdown.Toggle
                                              split
                                              variant='outline-primary'
                                              size='sm'
                                              id='dropdown-custom-2'
                                              style={{border: '1px solid #3e97ff'}}
                                            />
                                            <Dropdown.Menu className='dropdown-menu-commissionReport'>
                                              {(node.status === 'APPROVED' ||
                                                node.status === 'NOT_ASSIGNED') && (
                                                <Dropdown.Item
                                                  eventKey='mark-pending'
                                                  onClick={() =>
                                                    handleStatusChange(node, 'PENDING')
                                                  }
                                                >
                                                  <i className='bi bi-check-square-fill' /> Mark
                                                  as Pending
                                                </Dropdown.Item>
                                              )}
                                              <Dropdown.Item
                                                eventKey='editDetail'
                                                onClick={(e) => {
                                                  e.preventDefault()
                                                  setInfoEditDetail(node)
                                                  setIsOpenEditDetail(true)
                                                }}
                                              >
                                                <i className='bi bi-pencil-square' /> Update
                                              </Dropdown.Item>

                                              <Dropdown.Item
                                                eventKey='reassign'
                                                onClick={() => {
                                                  setInfoEditDetail(node)
                                                  setIsOpenAssignAgent(true)
                                                }}
                                              >
                                                <i className='bi bi-pencil-fill' /> Reassign
                                              </Dropdown.Item>

                                              <Dropdown.Divider />
                                              <Dropdown.Item
                                                eventKey='delete'
                                                onClick={() => {
                                                  onOpenDeleteCommissionReportDetail()
                                                  setInfoEditDetail(node)
                                                }}
                                              >
                                                <i className='bi bi-check-square-fill' /> Delete
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                                <tr>
                                  <td
                                    colSpan={6}
                                    style={{
                                      backgroundColor: '#9fddaeff',
                                      color: 'black',
                                      textAlign: 'right',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    Total Approved to pay:
                                  </td>
                                  <td
                                    colSpan={2}
                                    style={{
                                      backgroundColor: '#9fddaeff',
                                      color: 'black',
                                      textAlign: 'left',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {parsePrice(totals.approvedWithoutPolicy)}
                                  </td>
                                </tr>
                              </>
                            )}

                            {/* Si es DRAFT, mostrar sección con carrier name. Si es COMPLETED, solo los registros */}
                            {isDraft && withPolicy.length > 0 && (
                              <>
                                <tr>
                                  <td
                                    colSpan={8}
                                    style={{
                                      backgroundColor: '#337ab7',
                                      color: 'black',
                                      textAlign: 'left',
                                      padding: '8px',
                                    }}
                                  >
                                    <strong>{report.carrier.name} </strong>
                                  </td>
                                </tr>
                                {withPolicy.map(({node}) => (
                                  <tr key={node.id}>
                                    <td>
                                      <div>
                                        <span
                                          className='text-primary'
                                          style={{cursor: 'pointer'}}
                                          data-tooltip-id={`myt2${parseId(node.id)}`}
                                        >
                                          {node.client}
                                          {node.activeClaim && (
                                            <i
                                              className='bi bi-exclamation-circle-fill text-danger'
                                              title='This client has an active claim'
                                            />
                                          )}
                                        </span>
                                        <p className='m-0'>Member ID: {node.memberId}</p>
                                        <p className='m-0'>State: {node.stateEU?.code}</p>
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <span className='text-primary'>
                                          {node.user.firstName} {node.user.lastName}
                                          <p style={{maxWidth: '140px', wordBreak: 'break-all'}}>
                                            NPN: {node.user.npn}
                                          </p>
                                        </span>
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <span
                                          className={`commission-type ${node.commissionType.toLowerCase()}`}
                                          style={{maxWidth: '140px', wordBreak: 'break-all'}}
                                        >
                                          {node.commissionType}
                                        </span>
                                        {formatEffectivePeriod(node.effectiveMonth, node.effectiveYear) && (
                                          <p className='m-0'>
                                            Month:{' '}
                                            {formatEffectivePeriod(node.effectiveMonth, node.effectiveYear)}
                                          </p>
                                        )}
                                      </div>
                                    </td>
                                    <td>
                                      <BadgeStatus state={node.status} />
                                    </td>
                                    <td>{parsePrice(node.rate)}</td>
                                    <td>{node.members}</td>
                                    <td>{parsePrice(node.subtotal)}</td>
                                    <td
                                      className='d-flex gap-2 align-items-center'
                                      style={{minWidth: '120px'}}
                                    >
                                      {canEditCommission && report.status === 'DRAFT' && (
                                        <>
                                          {(node.status === 'PENDING' ||
                                            node.status === 'NOT_ASSIGNED') && (
                                              <OverlayTrigger
                                                placement='top'
                                                overlay={
                                                  <Tooltip id={`tooltip-approve-${node.id}`}>
                                                    Mark as Approved
                                                  </Tooltip>
                                                }
                                              >
                                                <i
                                                  className='bi bi-check-square-fill text-success'
                                                  style={{cursor: 'pointer', fontSize: '1.2rem'}}
                                                  onClick={() =>
                                                    handleStatusChange(node, 'APPROVED')
                                                  }
                                                />
                                              </OverlayTrigger>
                                            )}

                                          {(node.status === 'PENDING' ||
                                            node.status === 'APPROVED') && (
                                              <OverlayTrigger
                                                placement='top'
                                                overlay={
                                                  <Tooltip id={`tooltip-notassigned-${node.id}`}>
                                                    Mark as Not Assigned
                                                  </Tooltip>
                                                }
                                              >
                                                <i
                                                  className='bi bi-x-square-fill text-danger'
                                                  style={{cursor: 'pointer', fontSize: '1.2rem'}}
                                                  onClick={() =>
                                                    handleStatusChange(node, 'NOT_ASSIGNED')
                                                  }
                                                />
                                              </OverlayTrigger>
                                            )}
                                          <Dropdown as={ButtonGroup}>
                                            <Button
                                              variant='outline-primary'
                                              size='sm'
                                              style={{border: '1px solid #3e97ff'}}
                                            >
                                              Actions
                                            </Button>
                                            <Dropdown.Toggle
                                              split
                                              variant='outline-primary'
                                              size='sm'
                                              id='dropdown-custom-2'
                                              style={{border: '1px solid #3e97ff'}}
                                            />
                                            <Dropdown.Menu className='dropdown-menu-commissionReport'>
                                              {(node.status === 'APPROVED' ||
                                                node.status === 'NOT_ASSIGNED') && (
                                                <Dropdown.Item
                                                  eventKey='mark-pending'
                                                  onClick={() =>
                                                    handleStatusChange(node, 'PENDING')
                                                  }
                                                >
                                                  <i className='bi bi-check-square-fill' /> Mark
                                                  as Pending
                                                </Dropdown.Item>
                                              )}
                                              <Dropdown.Item
                                                eventKey='editDetail'
                                                onClick={(e) => {
                                                  e.preventDefault()
                                                  setInfoEditDetail(node)
                                                  setIsOpenEditDetail(true)
                                                }}
                                              >
                                                <i className='bi bi-pencil-square' /> Update
                                              </Dropdown.Item>

                                              <Dropdown.Item
                                                eventKey='reassign'
                                                onClick={() => {
                                                  setInfoEditDetail(node)
                                                  setIsOpenAssignAgent(true)
                                                }}
                                              >
                                                <i className='bi bi-pencil-fill' /> Reassign
                                              </Dropdown.Item>

                                              <Dropdown.Divider />
                                              <Dropdown.Item
                                                eventKey='delete'
                                                onClick={() => {
                                                  onOpenDeleteCommissionReportDetail()
                                                  setInfoEditDetail(node)
                                                }}
                                              >
                                                <i className='bi bi-check-square-fill' /> Delete
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                                <tr>
                                  <td
                                    colSpan={6}
                                    style={{
                                      backgroundColor: '#9fddaeff',
                                      color: 'black',
                                      textAlign: 'right',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    Total Approved to pay:
                                  </td>
                                  <td
                                    colSpan={2}
                                    style={{
                                      backgroundColor: '#9fddaeff',
                                      color: 'black',
                                      textAlign: 'left',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {parsePrice(totals.approvedWithPolicy)}
                                  </td>
                                </tr>
                              </>
                            )}

                            {/* Si el reporte está COMPLETED, mostrar todos los registros sin separar */}
                            {!isDraft && currentPageItems.map(({node}) => (
                              <tr key={node.id}>
                                <td>
                                  <div>
                                    <span
                                      className='text-primary'
                                      style={{cursor: 'pointer'}}
                                      data-tooltip-id={`myt2${parseId(node.id)}`}
                                    >
                                      {node.client}
                                      {node.activeClaim && (
                                        <i
                                          className='bi bi-exclamation-circle-fill text-danger'
                                          title='This client has an active claim'
                                        />
                                      )}
                                    </span>
                                    {(node.memberId || node.stateEU?.code) && (
                                      <>
                                        {node.memberId && <p className='m-0'>Member ID: {node.memberId}</p>}
                                        {node.stateEU?.code && <p className='m-0'>State: {node.stateEU?.code}</p>}
                                      </>
                                    )}
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    <span className='text-primary'>
                                      {node.user.firstName} {node.user.lastName}
                                      <p style={{maxWidth: '140px', wordBreak: 'break-all'}}>
                                        NPN: {node.user.npn}
                                      </p>
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    <span
                                      className={`commission-type ${node.commissionType.toLowerCase()}`}
                                      style={{maxWidth: '140px', wordBreak: 'break-all'}}
                                    >
                                      {node.commissionType}
                                    </span>
                                    {formatEffectivePeriod(node.effectiveMonth, node.effectiveYear) && (
                                      <p className='m-0'>
                                        Month: {formatEffectivePeriod(node.effectiveMonth, node.effectiveYear)}
                                      </p>
                                    )}
                                  </div>
                                </td>
                                <td>
                                  <BadgeStatus state={node.status} />
                                </td>
                                <td>{parsePrice(node.rate)}</td>
                                <td>{node.members}</td>
                                <td>{parsePrice(node.subtotal)}</td>
                                <td
                                  className='d-flex gap-2 align-items-center'
                                  style={{minWidth: '120px'}}
                                >
                                  {report.status === 'COMPLETED' && (
                                    <Button
                                      size='sm'
                                      variant='primary'
                                      onClick={() => {
                                        setIsOpenNotesClaims(true)
                                        setInfoEditDetail(node)
                                      }}
                                    >
                                      <i className='bi bi-chat-dots' /> Notes | Claims
                                    </Button>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </>
                        )
                      })()}
                  </tbody>
                )}
              </table>
            </div>
          </div>
        </Col>
      </Row>
      {canUseCommissionsFinder && (
        <>
          <Button
            style={floatingTabStyle}
            variant='light'
            title='Commissions Finder'
            onClick={onOpenSearchDetails}
          >
            <i className='bi bi-search fs-4' />
          </Button>

          <OffcanvasSearchCommissionDetails
            isOpen={isOpenSearchDetails}
            onClose={onCloseSearchDetails}
          />
        </>
      )}

      {/*
      showAside && (
        <AsideMenucommissionReports
          isOpen={showAside}
          onClose={() => setShowAside(false)}
          tabFilters={tabFilters}
          setTabFilters={setTabFilters}
        />
      )
      */}

      {isOpen && (
        <ModalAddCommissionReportDetail
          refetch={refetchEntries}
          isOpen={isOpen}
          onClose={onClose}
          commissionReportId={report.id}
          defaultEffectiveMonth={report.effectiveMonth}
          defaultEffectiveYear={report.effectiveYear}
        />
      )}

      {isOpenEdit && infoEdit && (
        <ModalEditCommissionReport
          isOpen={isOpenEdit}
          onClose={() => {
            setIsOpenEdit(false)
          }}
          infoEdit={infoEdit}
          refetch={refetchReport}
        />
      )}

      {isOpenEditDetail && (
        <ModalEditCommissionReportDetail
          isOpen={isOpenEditDetail}
          onClose={() => {
            setIsOpenEditDetail(false)
          }}
          infoEdit={infoEditDetail}
          refetch={refetchEntries}
        />
      )}

      {isOpenAssignAgent && (
        <ModalAssignAgent
          isOpen={isOpenAssignAgent}
          onClose={() => setIsOpenAssignAgent(false)}
          infoEdit={infoEditDetail}
          refetch={refetchEntries}
        />
      )}
      {isOpenDeleteCommissionReportDetail && infoEditDetail && (
        <ModalDeleteCommissionReportDetail
          isOpen={isOpenDeleteCommissionReportDetail}
          onClose={() => {
            onCloseDeleteCommissionReportDetail()
          }}
          infoEdit={{id: infoEditDetail.id}}
          refetch={refetchEntries}
        />
      )}
      {isOpenNotesClaims && (
        <ModalNotesClaims
          isOpen={isOpenNotesClaims}
          onClose={() => {
            setIsOpenNotesClaims(false)
          }}
          infoEdit={infoEditDetail}
          refetch={refetchEntries}
        />
      )}
      {isOpenToggleModal && (
        <ModalConfirmation
          isOpen={isOpenToggleModal}
          onClose={() => setIsOpenToggleModal(false)}
          onConfirm={handleToggleStatus}
          refetch={refetchEntries}
          title={toggleAction === 'close' ? 'Close Report' : 'Reopen Report'}
          confirmText={toggleAction === 'close' ? 'Yes, Close Report' : 'Yes, Reopen Report'}
          confirmVariant={toggleAction === 'close' ? 'danger' : 'success'}
          body={
            toggleAction === 'close' ? (
              <>
                <p>
                  <strong>Are you sure you wish to close this report?</strong>
                </p>
                <ul>
                  <li>
                    All <strong>PENDING</strong> policies will be marked as{' '}
                    <strong>NOT ASSIGNED</strong>.
                  </li>
                  <li>You confirm the rates and assignments are final.</li>
                </ul>
              </>
            ) : (
              <p>
                <strong>Are you sure you want to reopen this report?</strong>
                <br />
                All <strong>NOT ASSIGNED</strong> policies will be marked as{' '}
                <strong>PENDING</strong>.
              </p>
            )
          }
        />
      )}
      {isOpenDeductionsModal && (
        <ModalConfirmation
          isOpen={isOpenDeductionsModal}
          refetch={refetchEntries}
          onClose={() => setIsOpenDeductionsModal(false)}
          onConfirm={handleConfirmCalculateDeductions}
          title='Calculate Deductions'
          confirmText='Yes, Calculate'
          confirmVariant='primary'
          body={
            <p>
              <strong>Are you sure you want to calculate deductions?</strong>
              <br />
              This will run the deduction calculation logic and may update the report's values.
            </p>
          }
        />
      )}

      {/* Modal para seleccionar tipo de upload */}
      {isOpenUploadTypeModal && (
        <ModalConfirmation
          isOpen={isOpenUploadTypeModal}
          refetch={() => {}}
          onClose={() => {
            setIsOpenUploadTypeModal(false)
            pendingFileRef.current = null
          }}
          onConfirm={handleConfirmUpload}
          title='Select Upload Type'
          confirmText={
            uploadType === 'commission' ? (
              <>
                <i className='bi bi-cash-stack me-2'></i>
                Upload as Commission
              </>
            ) : (
              <>
                <i className='bi bi-gift me-2'></i>
                Upload as Bonus
              </>
            )
          }
          confirmVariant='primary'
          body={
            <div>
              <p>
                <strong>What type of payment are you uploading?</strong>
              </p>
              <Form.Group className='mt-3'>
                <Form.Check
                  type='radio'
                  id='upload-commission'
                  label='Commission Payment'
                  checked={uploadType === 'commission'}
                  onChange={() => setUploadType('commission')}
                />
                <Form.Text className='text-muted ms-4'>
                  Upload regular commission payments for agents
                </Form.Text>
              </Form.Group>
              <Form.Group className='mt-2'>
                <Form.Check
                  type='radio'
                  id='upload-bonus'
                  label='Bonus Payment'
                  checked={uploadType === 'bonus'}
                  onChange={() => setUploadType('bonus')}
                />
                <Form.Text className='text-muted ms-4'>
                  Upload bonus payments. All approved records will be marked as BONUS type.
                </Form.Text>
              </Form.Group>
            </div>
          }
        />
      )}
    </div>
  )
}
